import { HttpClient, WebResponse } from '@src/service'
import { MattermostSessionResponse, MattermostConfigResponse } from '../types'

export const getMattermostSession = async (
  httpClient: HttpClient,
  organizationId: string
): Promise<WebResponse<MattermostSessionResponse>> => {
  return httpClient.post('mattermost/session', { organizationId })
}

export const getMattermostConfig = async (
  httpClient: HttpClient
): Promise<WebResponse<MattermostConfigResponse>> => {
  return httpClient.get('mattermost/config')
}

export const checkTokenHealth = async (
  httpClient: HttpClient
): Promise<WebResponse<{ valid: boolean }>> => {
  return httpClient.get('mattermost/token-health')
}

export const syncOrgMattermost = async (
  httpClient: HttpClient,
  orgId: string
): Promise<WebResponse<{ synced: number }>> => {
  return httpClient.post(`mattermost/sync-org/${orgId}`, {})
}
